import config from '@/config';

// Base API configuration
export const API_CONFIG = {
    BASE_URL: config.apiUrl,
} as const;

const v2 = (path: string) => `/api/v2/${path}`;
const v1 = (path: string) => `/api/${path}`;

// API endpoints
export const API_ENDPOINTS = {
    // Health
    HEALTH: v1('health'),

    // Auth
    AUTH: v1('auth'),
    AUTH_CHECK: v1('auth/check'),
    AUTH_LOGOUT: v1('auth/logout'),
    AUTH_ORIGINAL_API_KEY: v1('auth/original-api-key'),

    // Calls
    CALLS: v2('calls'),
    CALL_BY_ID: (id: string | number) => v2(`calls/${id}`),
    CALL_RECORDING: (id: string | number) => v1(`calls/${id}/recording`),
    CALL_INSIGHTS: (id: string | number) => v2(`calls/${id}/insights`),
    CAMPAIGNS_FOR_CALLS: v1('calls/campaigns'),

    // Agents
    AGENTS: v1('agents'),
    AGENT_BY_ID: (id: string | number) => v1(`agents/${id}`),
    AGENT_CALLS: (id: string | number) => v1(`agents/${id}/calls`),

    // Campaigns
    CAMPAIGNS: v1('campaigns'),
    CAMPAIGN_BY_ID: (id: string | number) => v1(`campaigns/${id}`),
    CAMPAIGN_AGENTS: (id: string | number) => v1(`campaigns/${id}/agents`),
    CAMPAIGN_QUESTIONS: (id: string | number) => v2(`campaigns/${id}/questions`),
    CAMPAIGN_QUESTIONS_COPY: v2('campaigns/questions/copy'),
    CAMPAIGN_QUESTIONS_CALCULATE_FORMULA: v2('campaigns/questions/calculate-formula'),
    GET_CAMPAIGN_QUESTIONS_CALCULATE_FORMULA: (id: string | number) => v2(`campaigns/${id}/quality-score-formula`),

    // OpenAI
    OPENAI_CALL_INSIGHTS: v2('openai/call-insights'),

    // OpenAI
    OPENAI_QUERY: v1('openai/query'),

    // Status
    STATUS: v1('status'),

    // Settings
    SETTINGS: v1('settings'),

    // Global prompts
    GLOBAL_PROMPT_QUESTIONS: v2('global-prompts/questions'),
    GLOBAL_PROMPT_INSIGHTS: v2('global-prompts/insights'),
    GLOBAL_PROMPT_INSIGHTS_STATUS: v2('global-prompts/insights/status'),

    // Insight feedback
    CALL_INSIGHT_FEEDBACK: (callId: string | number) => v2(`calls/${callId}/insights/feedback`),
    CALL_INSIGHT_FEEDBACK_BY_QUESTION: (callId: string | number, questionId: string | number) =>
        v2(`calls/${callId}/insights/feedback/${questionId}`),
} as const;

// Query parameter builders
export const buildQueryParams = (params: Record<string, string | number | boolean>) => {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            searchParams.append(key, String(value));
        }
    });

    return searchParams.toString();
};

// Helper to build full URL with query params
export const buildApiUrl = (endpoint: string, params?: Record<string, string | number | boolean>) => {
    const queryString = params ? buildQueryParams(params) : '';

    return queryString ? `${API_CONFIG.BASE_URL}${endpoint}?${queryString}` : `${API_CONFIG.BASE_URL}${endpoint}`;
};
